"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_jss_1 = require("react-jss");
exports.default = react_jss_1.createUseStyles({
    kbd: function (_a) {
        var theme = _a.theme;
        return ({
            lineHeight: theme.lineHeight,
            fontFamily: theme.fontFamilyMonospace,
            fontSize: theme.fontSizes.xs,
            fontWeight: 700,
            backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[5] : theme.colors.gray[0],
            color: theme.colorScheme === 'dark' ? theme.colors.dark[0] : theme.colors.gray[7],
            padding: [3, theme.spacing.xs / 2],
            borderRadius: theme.radius.sm,
            border: "1px solid " + (theme.colorScheme === 'dark' ? theme.colors.dark[9] : theme.colors.gray[3]),
            borderBottomWidth: 3,
        });
    },
}, { link: true });
